import * as React from 'react';
export const IcTemperatureOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.714 19.29l-16-16a1.004 1.004 0 10-1.42 1.42l4.71 4.7V14a5 5 0 007.54 6.54 5.05 5.05 0 001.28-2.3l2.47 2.47a1.002 1.002 0 001.639-.325 1 1 0 00-.219-1.095zm-7.3-1.75a1.43 1.43 0 01-.56.7 1.52 1.52 0 01-1.7 0 1.47 1.47 0 01-.61-1.59 1.47 1.47 0 01.46-.76v-3.48l2 2v1.48c.228.2.389.465.46.76.08.294.062.606-.05.89zM11.004 6a1 1 0 112 0v2.76l3 3V6a4 4 0 00-6.83-2.83 4.07 4.07 0 00-.72 1l2.55 2.59V6z'
      fill='currentColor'
    />
  </svg>
);
